module.exports = __webpack_public_path__ + "img/illustration-danger.68b055d8.svg";